import { TiPlus } from "react-icons/ti"

interface Props {
  onClick?: () => void
  className?: string
}

function ButtonAdd({onClick, className}: Props) {
  return (
    <button 
      type="button"
      className={`text-white bg-green-400 focus:outline-none focus:ring-4 focus:ring-green-300 focus:bg-green-500 hover:bg-green-500 rounded p-2 ${className || ''}`}
      onClick={onClick}
    ><TiPlus /></button>
  )
}
  
export default ButtonAdd
